const React = require('react');
const {
  makeStyles,
  createStyles,
} = require('@material-ui/core/styles');
const FormControl = require('@material-ui/core/FormControl').default;
const SelectBase = require('@material-ui/core/Select').default;
const MenuItem = require('@material-ui/core/MenuItem').default;
const DropIcon = require('../../icons/Drop');
const selectProvider = require('./provider');


const useStyles = makeStyles((theme) => createStyles({
  paper: {
    backgroundColor: '#FFF',
    color: '#000',
  },
}));

function Select({env}) {
  const {
    select,
    label,
  } = env;
  const {
    className,
    label: _label,
    helperText,
    ...control
  } = env.control;
  const placeholder = label.children;
  const popoverClasses = useStyles();

  return (
    <div className={'layoutRow fhaS fvaC w ' + (className || '')}>
      <div
        className="c8B8D93 f14 fw5 w(|min)90 pr10 ff$2 __label"
      >{_label}</div>
      <div className="fx1 wmin0 rlv">
        <FormControl
          className="w"
          {...control}
        >
          <SelectBase
            {...select}
            className={`w ff$2 f14*2 r8*2 ov 
              (pv18|ph20|pr35|cF)>.*OutlinedInput-input
              (pr38)>.MuiSelect-select.MuiSelect-select
              b1>.*OutlinedInput-notchedOutline*3
              (bcEDEEF0):not[.Mui-error]>.*OutlinedInput-notchedOutline*2
              bgF0>.*Select-root*2
              ff$2>.*Select-select
              (c1D1E20|fw4|dn)>.*Select-select
              c0:not[.Mui-disabled]:h>.*Select-select
              (fill0)>.MuiSelect-icon
              (cA3A7AC)>.Mui-disabled.MuiInputBase-input
              (fillA3A7AC)>.Mui-disabled.MuiSelect-icon
              st-4.5>fieldset ` + (select.className || '')}
            IconComponent={DropIcon}
            MenuProps={{
              PopoverClasses: popoverClasses,
            }}
          >
            {
              placeholder ? (
                <MenuItem
                  value=""
                  disabled
                >{placeholder}</MenuItem>
              ) : null
            }
            {select.children}
          </SelectBase>
        </FormControl>
        {
          control.error ? (<div className="rlv">
            <div
              className="abs sh20 st f12 cEC4C4C fw4"
            >{helperText || 'Obligatory field'}</div>
          </div>) : null
        }
      </div>
    </div>
  );
}

module.exports = selectProvider((env) => (<Select env={env}/>));
